import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=ee1e34be&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=ee1e34be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1e34be",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fslider%2FSlider.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports